module.exports = new __parcel__URL__("GT_P_1Blau_reduziertHoch_004.39e73167.json").toString();